/*
We need this constant for define height of areas, where autoScroll will be run. Areas are located
on the top and on the bottom of ViewDropArea. If you are dragging element into this areas,
page will be scrolled up or down respectively.
*/
const AUTOSCROLL_AREA_HEIGHT = 100;
const MAX_SPEED = 20;

export { AUTOSCROLL_AREA_HEIGHT, MAX_SPEED };
